<div id="host">
  <h2>{{ 'menu-attestations' | translate }}</h2>
  <div class="filters d-flex flex-wrap">
    <app-datepicker style="margin-left: 2%" [stampdebut]="filtersActive().from" [stampfin]="filtersActive().to"
      [attestation]="true" (myDatePicker)="searchByTimestamp($event)"></app-datepicker>
    <app-filters-ac [defaultFilter]="filtersActive()" [objetAC]="promiseResult"
      (applyFilter)="searchRequestFilters($event)"></app-filters-ac>
    <button (click)="resetAll()" type="button" class="reset"></button>
  </div>

  @if (awaitChargementListe() && !loadingOerror()) {
  <div class="d-flex flex-row align-items-start canv">
    <div class="canevasListe d-flex flex-column" [id]="scoreInAttestations() ? 'canevasListe' : 'clwithoutScore'">
      <div class="d-flex justify-content-between flex-row">
        @if (!searchmodel() && filtersActive().from && filtersActive().to) {
        <h3>
          {{ 'attestations-title-h2' | translate }}
          {{ dateRangeTitle() }}
        </h3>
        <h3 class="datetotitle">
          {{ attestationDateRange() }}
        </h3>
        }
        @if (searchmodel() && searchmodel().length < 30) { <h3>{{ 'attestations-title-search-h2' | translate }} {{
          searchmodel() }}</h3>
          } @else {
          @if (searchmodel() && searchmodel().length > 30) {
          <h3 placement="top" ngbTooltip="{{ searchmodel() }}">
            {{ 'attestations-title-search-h2' | translate }} {{ formatId(searchmodel()) }}
          </h3>
          }
          }
          @if (searchmodel() && listBorn() && listBorn().length > 0) {
          <h3 class="datetotitle">
            {{ attestationDateRange() }}
          </h3>
          }
      </div>
      <div class="d-flex flex-wrap justify-content-center">
        <h4 class="result">{{ promiseResult?.totalNbRows }} {{ 'results' | translate }}</h4>
      </div>
      @if(promiseResult && awaitChargementListe()){
      <ngb-pagination [page]="page()" [maxSize]="4" [pageSize]="pageSize()" (pageChange)="nextPage($event)"
        [collectionSize]="promiseResult.totalNbRows" [rotate]="true" [ellipses]="false" [boundaryLinks]="true">
      </ngb-pagination>
      }
      <ul>
        @for (attestation of listBorn() | existingReports; track attestation.id) {
        <li class="d-flex flex-row align-items-center elem" [class.actif]="attestation === attesCourante()"
          (click)="setAttestationSelectionnee(attestation); scroolTo()">
          <div class="d-flex flex-column appandId">
            @if (attestation.appInfo?.appName) {
            <h4 class="elemTitre">
              {{ formatAPPName(attestation.appInfo.appName) }} - {{ attestation.appInfo.appVersion }}
            </h4>
            } @else {
            @if (attestation.appInfo?.appId) {
            <h4 class="elemTitre">
              {{ formatId(attestation.appInfo.appId) }} - {{ attestation.appInfo.appVersion }}
            </h4>
            }
            }
            <p class="text-center">{{ formatId(attestation.id) }}</p>
          </div>
          <hr class="elemListehr">
          <div class="d-flex flex-column device">
            @if (attestation.deviceInfo?.model) {
            <h4 class="elemTitre">{{ formatName(attestation.deviceInfo.model) }}</h4>
            <div class="d-flex flex-row align-items-center">
              <img class="icone{{ attestation.deviceInfo.platformName?.toLowerCase() }}"
                src="assets/icons/logosOS/{{ attestation.deviceInfo.platformName?.toLowerCase() }}.svg">
              @if (attestation.deviceInfo.platformName?.toLowerCase() == 'ios') {
              <h5 class="version-os">v.{{ formatVersion(attestation.deviceInfo.apiLevel) }}</h5>
              } @else {
              @if (attestation.deviceInfo.platformName?.toLowerCase() == 'android') {
              <h5 class="version-os">v.{{ formatVersion(attestation.deviceInfo.platformVersion) }}</h5>
              }
              }
            </div>
            } @else {
            @if (attestation.deviceInfo?.manufacturer) {
            <h4 class="elemTitre">{{ formatName(attestation.deviceInfo.manufacturer) }} - NA</h4>
            } @else {
            <h4 class="elemTitre">Unknown device</h4>
            }
            }
          </div>
          <div class="d-flex flex-column date">
            <h4 class="elemTitre">{{ titrefiltreDate(attestation.createdAt, today()) }}</h4>
            <h5>
              {{ datepipe.transform(attestation.createdAt, 'dd/MM/yyyy') }}
              <span>
                <h6>{{ datepipe.transform(attestation.createdAt, 'HH:mm') }}</h6>
              </span>
            </h5>
          </div>
          @if (scoreInAttestations() && attestation?.score_prevention) {
          <div *kaHasRoles="['bo-dip-scoring-viewer']; checkRealm: true" class="d-flex flex-column alerte">
            <h4 class="elemTitre">{{ 'alert' | translate }}</h4>
            @if (attestation.alert) {
            <img type="button" placement="top" ngbTooltip="{{ datepipe.transform(attestation.alert, 'dd/MM/yyyy') }}"
              src="assets/icons/AttestList/alertinactive.svg">
            } @else {
            <img src="assets/icons/AttestList/alertinactive.svg">
            }
          </div>
          <div *kaHasRoles="['bo-dip-scoring-viewer']; checkRealm: true" class="d-flex flex-column score">
            <h4 class="elemTitre">Score</h4>
            <mat-progress-spinner [color]="'primary'" [mode]="'determinate'"
              [value]="attestation.score_prevention.scorePrevention*100"
              [ngbTooltip]="(attestation.score_prevention?.scorePrevention*100).toString()">
            </mat-progress-spinner>
          </div>
          }
          <img class="side-arrow" src="assets/icons/ComprReport/down-arrow.svg">
        </li>
        }
      </ul>
      @if (promiseResult && awaitChargementListe()) {
      <ngb-pagination [page]="page()" [maxSize]="4" [pageSize]="pageSize()" (pageChange)="nextPage($event)"
        [collectionSize]="promiseResult.totalNbRows" [rotate]="true" [ellipses]="false" [boundaryLinks]="true">
      </ngb-pagination>
      }
    </div>
    @if (attesCourante()) {
    <div *kaHasRoles="['bo-dip-scoring-viewer']; checkRealm: true" class="globalscore" id="scoreAtt">
      @if (scoreInAttestations()) {
      <h3 class="d-flex flex-row justify-content-center">{{ 'attestations-title-detectors' | translate }} <span
          class="id">{{ formatId(attesCourante()?.id ?? '') }}</span></h3>
      <hr class="accordeon-hr v2">
      <div class="preventionalScore">
        <h4>{{ 'preventional-score' | translate }}</h4>
        <app-preventional-score [scoreCourant]="attesCourante()?.score_prevention"></app-preventional-score>
        <hr class="accordeon-hr v2">
      </div>
      <div class="d-flex justify-content-center button-details">
        <app-attestation-modal [listeprobes]="getAllFamilies()" [attestationCourante]="attesCourante()"
          (filtreApp)="filtreAppNamefromAll($event)"></app-attestation-modal>
      </div>
      } @else {
      <h3 class="d-flex flex-row justify-content-center">{{ 'compromise-reports-title-details' | translate }} <h3
          class="id">{{ formatId(attesCourante()?.id ?? '') }}</h3>
      </h3>
      <details-attestations-without-score [listeprobes]="getAllFamilies()" [attestation]="true"
        [objetCourant]="attesCourante()" (filtreApp)="filtreAppNamefromAll($event)">
      </details-attestations-without-score>
      }
    </div>
    }
  </div>
  } @else {
  @if (loadingOerror()) {
  <app-loading-error [boolean]="true" [message]="'waiting-for-attestation' | translate"></app-loading-error>
  } @else {
  @if (!awaitChargementListe() && searchmodel()) {
  <app-loading-error [boolean]="false"
    [search]="('component-error-search-attestation' | translate) + ' ' + searchmodel()"
    [order]="'component-attestation-search-order' | translate"></app-loading-error>
  } @else {
  @if (!awaitChargementListe() && filtersActive().from && filtersActive().to && datepipe.transform(filtersActive().from,
  'dd/MM/yyyy') !== datepipe.transform(filtersActive().to, 'dd/MM/yyyy')) {
  <app-loading-error [boolean]="false"
    [search]="('component-error-search-attestation' | translate) + ' ' + datepipe.transform(filtersActive().from, 'dd/MM/yyyy') + ' - ' + datepipe.transform(filtersActive().to, 'dd/MM/yyyy')"
    [order]="'component-error-filter-order' | translate"></app-loading-error>
  } @else {
  <app-loading-error [boolean]="false"
    [search]="('component-error-search-attestation' | translate) + ' ' + datepipe.transform(filtersActive().from, 'dd/MM/yyyy')"
    [order]="'component-error-filter-order' | translate"></app-loading-error>
  }
  }
  }
  }
</div>
<app-toast-component></app-toast-component>